export default{'awaitingPromise':new WeakMap(),'promise':new WeakMap(),'innerParams':new WeakMap(),'domCache':new WeakMap()};